import React from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { Container, Grid, useMantineTheme, Box, Group, Flex } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { IconFilter, IconReload, IconCirclePlus } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { BE_API_THREE, utils } from "../../utils/globalVariables";
import { regexNoStriped, getPropInSubLevelRole, safetyDecodeJWT } from "../../utils/globalFunctions";

import AmountOfData from "../../components/general/AmountOfData";
import ActionIconComponent from "../../components/general/ActionIconComponent";
import NoData from "../../components/general/NoData";
import WrapperUtils from "../../layout/WrapperUtils";

import DeliveryJemputCard from "./DeliveryJemputCard";
import DeliveryJemputNotaAdd from "./DeliveryJemputNotaAdd";
import SearchInputComponent from "../../components/general/SearchInputComponent";
// import StockItemFilter from "./StockItemFilter";

import CustomerSelectorDrawer from "../../components/utilities/CustomerSelectorDrawer";

const DeliveryJemputNotaIndex = ({
    stateMenu,
    stateSubMenu,
    stateTab
}) => {

    const mountedRef = React.useRef(true);

    const navigate = useNavigate();
    const theme = useMantineTheme();
    const matchesMinMD = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorGetData: 'deliveryJemputNotaIndex-1',
        successBatalkanNota: 'deliveryJemputNotaIndex-2',
    })

    const filterDefaultRef = React.useRef({
        customerCategory: {
            show: false,
            id: utils.flagAll,
            name: '',
        },
        tanggalJemputDari: null,
        tanggalJemputSampai: null,
    })

    const sortList = {
        tanggalPenjemputan: {
            slug: 'waktu_jemput',
            caption: 'Tanggal Jemput',
            type: utils.sortType.date.slug
        },
        customerName: {
            slug: 'customer_name',
            caption: 'Customer',
            type: utils.sortType.string.slug
        },
        deliveryId: {
            slug: 'delivery_jemput_id',
            caption: 'No Penjemputan',
            type: utils.sortType.string.slug
        },
        deliveryMan: {
            slug: 'delivery_man_name',
            caption: 'Delivery Man',
            type: utils.sortType.string.slug
        },
    }

    const [data, setData] = React.useState({
        data: [],
        dataCount: 0,
        dataFlag: 'idle',
        dataLoading: false,
        dataRefresh: new Date(),
        dataOffset: 0,
        dataSortSelected: sortList.tanggalPenjemputan,
        dataSearchInputForBE: '',

        filterData: {
            drawer: false,
            customerCategory: filterDefaultRef.current.customerCategory,
            tanggalJemputDari: filterDefaultRef.current.tanggalJemputDari,
            tanggalJemputSampai: filterDefaultRef.current.tanggalJemputSampai,
        },

        customerSelector: {
            show: false,
            dataSelected: {
                triggerUseEffect: new Date(),
            }
        },
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const fnSort = (stateSortSelected) => {
        setData(d => ({
            ...d,
            dataLoading: true,
            dataSortSelected: {
                ...d.dataSortSelected,
                slug: d.dataSortSelected.slug[0] === '-' ? stateSortSelected.slug : '-' + stateSortSelected.slug,
                caption: stateSortSelected.caption,
                type: stateSortSelected.type
            }
        }));
    };

    const AmountOfDataComponent = () => {
        return (
            <AmountOfData
                stateDataLimit={utils.dataLimit}
                stateDataOffset={data.dataOffset}
                stateAmountDataAll={data.dataCount}
                stateDataFlag={data.dataFlag}
                stateSuffix=''

                fnFirstData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnLastData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnPreviousData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnNextData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}
            />
        )
    }

    React.useEffect(() => {
        setData(d => ({ ...d, dataLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('data_limit', utils.dataLimit);
        formDT.append('data_offset', data.dataOffset);
        formDT.append('order_by', regexNoStriped(data.dataSortSelected.slug));
        formDT.append('order_type', data.dataSortSelected.slug[0] === '-' ? 'asc' : 'desc');

        formDT.append('flag_all', utils.flagAll);
        formDT.append('filter_search', data.dataSearchInputForBE);

        formDT.append('penjemputan_step', utils.penjemputanSteps.nota.value);
        formDT.append('penjemputan_is_cancel', '0');

        axios({
            method: 'post',
            url: BE_API_THREE + '/list_penjemputan_batch_1',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, dataLoading: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({
                    ...d,
                    data: response.data.data,
                    dataCount: response.data.data_count,
                    dataFlag: response.data.data.length > 0 ? true : false,
                }));
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                dataLoading: false,
            }));

            notifications.show({
                id: notificationId.current.errorGetData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }, [handleSetLoginContext, loginContext.syswebapp, data.dataRefresh, data.dataSearchInputForBE, data.dataSortSelected.slug, data.dataOffset])

    const handleCloseDrawer = React.useCallback(() => {
        navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateMenu}/${stateSubMenu}/${stateTab}`, { replace: true });
    }, [loginContext, navigate, stateMenu, stateSubMenu, stateTab])

    const fnRefreshCallBack = React.useCallback(() => {
        setData(d => ({ ...d, dataRefresh: new Date() }));
    }, [])

    return (
        <React.Fragment>
            <WrapperUtils
                stateDataLoading={data.dataLoading}
            >
                <Group spacing='xs' noWrap>
                    <ActionIconComponent
                        stateVariant='light'
                        stateRadius='xl'
                        stateTitle='Filter'
                        stateSize='lg'
                        fnOnClick={() => setData(d => ({
                            ...d,
                            filterData: {
                                ...d.filterData,
                                drawer: true
                            }
                        }))}

                        StateIcon={IconFilter}
                        stateIconSize='1.125rem'
                        stateIconStrokeWidth={1.25}
                        stateIconStyle={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />

                    <ActionIconComponent
                        stateVariant='light'
                        stateRadius='xl'
                        stateTitle='Add'
                        stateSize='lg'
                        fnOnClick={() => setData(d => ({
                            ...d,
                            customerSelector: {
                                ...d.customerSelector,
                                show: true
                            }
                        }))}

                        StateIcon={IconCirclePlus}
                        stateIconSize='1.25rem'
                        stateIconStrokeWidth={1.25}
                        stateIconStyle={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />

                    <ActionIconComponent
                        stateVariant='light'
                        stateRadius='xl'
                        stateTitle='Reload Data'
                        stateSize='lg'
                        fnOnClick={() => setData(d => ({ ...d, dataLoading: true, dataRefresh: new Date() }))}

                        StateIcon={IconReload}
                        stateIconSize='1.125rem'
                        stateIconStrokeWidth={1.25}
                        stateIconStyle={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />

                    <SearchInputComponent
                        statePlaceHolder='Search Penjemputan'
                        fnDoSearch={(val) => setData(d => ({
                            ...d,
                            dataOffset: 0,
                            dataSearchInputForBE: val,
                            dataRefresh: new Date(),
                        }))}
                    />
                </Group>

                {matchesMinMD &&
                    <Flex
                        sx={{ flex: 1 }}
                        justify="flex-end"
                        align="center"
                        direction="row"
                        wrap="nowrap"
                    >
                        <AmountOfDataComponent />
                    </Flex>
                }
            </WrapperUtils>

            <Container fluid>
                <Grid my={0}>
                    {data.data.length <= 0 && data.dataFlag !== 'idle' &&
                        <Grid.Col span={12}>
                            <NoData />
                        </Grid.Col>
                    }

                    {data.data.length > 0 &&
                        <Grid.Col
                            span={12}
                            py={0}
                        >
                            <Box mt='md'>
                                <DeliveryJemputCard
                                    stateData={data.data}
                                    stateSortList={sortList}
                                    stateSortSelected={data.dataSortSelected}
                                    fnSort={(val) => {
                                        fnSort(val);
                                    }}

                                    fnSelectedData={(arrayVal) => {
                                        navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateMenu}/${stateSubMenu}/${stateTab}/${arrayVal.customer_id}`, { replace: true });

                                        setData(d => ({ ...d, dataRefresh: new Date(), dataLoading: true }));
                                        // ! apakah ini perlu ? perlu update index sewaktu pilih nota ?
                                    }}
                                />
                            </Box>
                        </Grid.Col>
                    }

                    {data.data.length > 0 &&
                        <Grid.Col span={12} className='amountOfDataBottom'>
                            <Group mt='xs' mb='md' position='apart'>
                                <Box>&nbsp;</Box>

                                <AmountOfDataComponent />
                            </Group>
                        </Grid.Col>
                    }
                </Grid>
            </Container>

            {/* <StockItemFilter
                stateShow={data.filterData.drawer}
                fnShow={() => setData(d => ({
                    ...d,
                    filterData: {
                        ...d.filterData,
                        drawer: false
                    }
                }))}

                stateDefaultFilter={{
                    ...filterDefaultRef.current,
                }}

                stateFilter={{
                    stockCategory: data.filterData.stockCategory,
                    stockCategorySub: data.filterData.stockCategorySub,
                    stockSupplier: data.filterData.stockSupplier,
                    stockIsActive: data.filterData.stockIsActive,
                    stockTanggalBeliDari: data.filterData.stockTanggalBeliDari,
                    stockTanggalBeliSampai: data.filterData.stockTanggalBeliSampai,
                    stockTanda: data.filterData.stockTanda,
                }}

                fnFilter={(category, categorySub, supplier, isActive, tglBeliDari, tglBeliSampai, tanda) => {

                    setData(d => ({
                        ...d,
                        filterData: {
                            ...d.filterData,
                            stockCategory: {
                                ...d.filterData.stockCategory,
                                id: category
                            },
                            stockCategorySub: {
                                ...d.filterData.stockCategorySub,
                                id: categorySub
                            },
                            stockSupplier: {
                                ...d.filterData.stockSupplier,
                                id: supplier
                            },
                            stockIsActive: isActive,
                            stockTanggalBeliDari: tglBeliDari,
                            stockTanggalBeliSampai: tglBeliSampai,
                            stockTanda: tanda,

                            drawer: false
                        },

                        dataRefresh: new Date(),
                        dataLoading: true,
                    }));
                }}
            /> */}

            <DeliveryJemputNotaAdd
                fnCloseDrawer={handleCloseDrawer}
                fnRefreshIndex={fnRefreshCallBack}
                fnSuccessBatal={() => {
                    handleCloseDrawer();
                    fnRefreshCallBack();

                    notifications.show({
                        id: notificationId.current.successBatalkanNota,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Submit Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }}
            />

            <CustomerSelectorDrawer
                stateShow={data.customerSelector.show}
                fnShow={() => setData(d => ({
                    ...d,
                    customerSelector: {
                        ...d.customerSelector,
                        show: false
                    }
                }))}

                stateData={{
                    customerIsActive: '1',
                    customerCategoryIsActive: '1',
                }}

                fnOnSelect={(object) => {
                    navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateMenu}/${stateSubMenu}/${stateTab}/${object.customerId}`, { replace: true });

                    setData(d => ({
                        ...d,
                        customerSelector: {
                            ...d.customerSelector,
                            show: false,
                            // dataSelected: {
                            //     ...d.customerSelector.dataSelected,
                            //     triggerUseEffect: new Date()
                            // }
                            // ! kyknya ga akan dipake. ini kyknya utk trigger refresh
                        }
                    }))
                }}
            />
        </React.Fragment>
    )
}

export default DeliveryJemputNotaIndex;